/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:19:50
 */
export default {
  lang: "英语",
  landing: {
    name1: "​ເປີດ Carlcare",
    name2: "ຈອງ",
    name3: "ດ້ວຍ Carlcare, ທ່ານ​ສາ​ມາດ​ກວດ​ເບິ່ງ​ຄຳ​ສັ່ງ​ຊື້​ຂອງ​ທ່ານ​ໄດ້​ຕະຫຼອດ​ເວ​ລາ.",
    name4: "",
    name5: "ເລື່ອນໄປທາງຂວາ",
    name6: "ການຢັ້ງຢືນສໍາເລັດ",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "ເລືອກລຸ້ນຂອງອຸປະກອນ",
    name2: "ຄໍາອະທິບາຍກ່ຽວກັບຂໍ້ຜິດພາດ:",
    name3: "ແຕະເພື່ອເລືອກຮ້ານຄ້າທີ່ໃຫ້ບໍລິການ",
    name4: "ຮ້ານຄ້າທີ່ໃຫ້ບໍລິການ:",
    name5: "ເວລານັດໝາຍ:",
    name6: "ກະລຸນາອະທິບາຍບັນຫາກ່ຽວກັບອຸປະກອນຂອງທ່ານຢ່າງລະອຽດ!",
    name7: "ແຕະເພື່ອເລືອກເວລາໄປຮອດ",
    name8: "ກະ​ລຸ​ນາ​ປ້ອນ​ລາຍ​ລະ​ອຽດ​ລາຍ​ຊື່​ຕິດ​ຕໍ່​ທີ່​ຖື​ກ​ຕ້ອງ​ຂອງ​ທ່ານ​ເພື່ອ​ໃຫ້​ພວກ​ເຮົາ​ສາ​ມາດ​ຕິດ​ຕໍ່​ທ່ານ​ໄດ້",
    name9: "ເວລາຈອງມີຄືດັ່ງນີ້",
    name10: "ກະລຸນາປ້ອນເບີໂທລະສັບຂອງທ່ານ",
    name11: "ລາຄາ",
    name12: "ຂໍ້ມູນສ່ວນບຸກຄົນ:",
    name13: "ກະລຸນາປ້ອນຊື່ຂອງທ່ານ",
    name14: "ສົ່ງຂໍ້ມູນ",
    name15: "​ຍົກ​ເລີກ",
    name16: "ຕົກ​ລົງ",
  },
  shops: {
    name1: "ຂຶ້ນກັບຍີ່ຫໍ້ທີ່ທ່ານເລືອກ, ຮ້ານຄ້າຕໍ່ໄປນີ້ສາມາດໃຫ້ບໍລິການທ່ານໄດ້!",
    name2: "​ໄວໆ​ນີ້​ໃນ​ຮ້ານ​ຄ້າ​ຍ່ອຍອື່ນໆ! ຢູ່​ກັບ​ພວກ​ເຮົາ!",
  },
  price: {
    name1: "ຍີ່ຫໍ້",
    name2: "ຮຸ່ນ",
    name3: "​ລາຍ​ການ",
    name4: "ລາຄາ",
    name5: "ການເຕືອນແບບເປັນມິດ:",
    name6: "ລາຄາເຫຼົ່ານີ້ແມ່ນການອ້າງອີງເທົ່ານັ້ນ ແລະ ລາຄາຕົວຈິງຈະຂຶ້ນກັບສະພາບອຸປະກອນຂອງທ່ານ.",
    name7: "ຖ້າບໍ່ມີສັນຍາລັກພິເສດ, ຫົວໜ່ວຍລາຄາແມ່ນຫົວໜ່ວຍສະກຸນເງິນທ້ອງຖິ່ນ.",
    name8: "ຂໍອະໄພ! ບໍ່​ມີ​ຂໍ້​ມູນ​ລາ​ຄາ​ໃນ​ພາກ​ພື້ນ​ປະ​ຈຸ​ບັນ.",
    name11:"ຄ່າແຮງງານ",
    name12:"ລາ​ຄາ​ລວມ",
    name13: "5. ຖ້າຄ່າແຮງງານແມ່ນ \"/\", ມັນໝາຍຄວາມວ່າຄ່າແຮງງານຕ້ອງປຶກສາຫາລືກັບຮ້ານ.",
    item_main_board: "ກະດານຫຼັກ",
    item_screen_frame: "ໜ້າຈໍ (ເຟຣມ)",
    item_screen_screen_frame: "ໜ້າຈໍສໍາຮອງ (ເຟຣມ)",
    item_touch_screen: "ໜ້າຈໍສໍາຜັດ",
    item_camera: "\"ກ້ອງ\"",
    item_fixed_focus_camera: "ກ້ອງໂຟກັສຄົງທີ່",
    item_auto_focus_camera: "ກ້ອງໂຟກັສອັດຕະໂນມັດ",
    item_screen: "ໜ້າຈໍ",
    item_secondary_screen: "ໜ້າຈໍສໍາຮອງ",
    item_fingerprint_module: "ໂມດູນລາຍນິ້ວມື",
    item_speaker: "ລຳໂພງ",
    item_receiver: "ຕົວ​ຮັບ​ຂໍ້​ມູນ",
    item_small_board: "ກະດານນ້ອຍ",
    item_battery_cover: "ຝາປິດແບັດເຕີຣີ",
    item_battery: "ແບັດເຕີຣີ",
    item_charger: "ເຄື່ອງສາກ",
    item_usb_cable: "ສາຍ USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ບໍ່ມີຂໍ້ມູນ",
    name2: "ຜູ້ໃຫ້ບໍລິການ:",
    name3: "ຍີ່ຫໍ້ຂອງບໍລິການ:",
    name4: "ເບີໂທລະສັບ:",
    name5: "ຈຳນວນການສັ່ງຊື້:",
    name6: "ຄະແນນການໃຫ້ບໍລິການ",
    name7: "ສະພາບແວດລ້ອມຂອງການໃຫ້້ບໍລິການ:",
    name8: "ທັດສະນະຄະຕິຂອງການໃຫ້ບໍລິການ:",
    name9: "ປະສິດທິພາບຂອງບໍລິການ:",
    name10: "ຄຸນນະພາບຂອງບໍລິການ:",
    name11: "ການປະເມີນຂອງລູກຄ້າ",
    name12:"ເຖິງ",
    name13:"ປິດ",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "​ເປີດ Carlcare",
    name1: "ກະ​ລຸ​ນາ​ຖ່າຍ​ຮູບ​ໜ້າ​ຈໍ​ຂໍ້​ມູນ​ການ​ຈ່ອງ ແລະ ບັນ​ທຶກ​ມັນ​ເປັນ​ໃບ​ຮັບ​ເງິນ​ເພື່ອ​ເຂົ້າ​ເຖິງ​ການ​ບໍ​ລິ​ການ​ທີ່​ມີ​ບຸ​ລິ​ມະ​ສິດ.",
    name2: "​ສົ່ງ​ສຳ​ເລັດ​ແລ້ວ",
    name3: "1. ອະ​ນາ​ໄມ​ຂໍ້​ມູນ",
    name4: "​ກະ​ລຸ​ນາ​ສຳ​ຮອງ​ຂໍ້​ມູນ​ສ່ວນ​ຕົວ​ທີ່​ສຳ​ຄັນ​ໃນ​ໂທ​ລະ​ສັບ​ຂອງ​ທ່ານ​ໄວ້​ລ່ວງ​ໜ້າ",
    name5: "2.​ປິດ​ໃຊ້​ງານລະ​ຫັດ​ຜ່ານ​ການ​ເປີດ​ເຄື່ອງ",
    name6: "ກ່ອນ​ທີ່​ຈະ​ໄປ​ທີ່​ຮ້ານ​ຄ້າທີ່ໃຫ້ບໍລິການ, ກະ​ລຸ​ນາ:",
    name7: "ຮ້ານຄ້າທີ່ໃຫ້ບໍລິການ:",
    name8: "ເວລານັດໝາຍ:",
    name9: "ຄໍາອະທິບາຍກ່ຽວກັບຂໍ້ຜິດພາດ:",
    name10: "​ລຸ້ນ​ຂອງອຸ​ປະ​ກອນ:",
    name11: "​ໝາຍ​ເລ​ກ​ການ​ສັ່ງ​ຊື້:",
    name12: "ຂໍ້ມູນການສັ່ງຊື່",
  },
  title: {
    
    name1: "ຮອງ​ຮັບ​ປະ​ເທດ​ຕໍ່​ໄປ​ນີ້:",
    name2: "​ເລືອກ​ລຸ້ນ",
    name3: "ການຈອງ",
    name4: "ລາຍລະອຽດຂອງຮ້ານຄ້າທີ່ໃຫ້ບໍລິການ",
    name5: "ເລືອກຮ້ານຄ້າທີ່ໃຫ້ບໍລິການ",
  },
  error: {
    
    name1: "ບໍ່ມີຂໍ້ມູນ. ກະ​ລຸ​ນາ​ກວດ​ເບິ່ງ​ຂໍ້​ມູ​ນ​ການ​ສ້ອມ​ແປງ​ຂອງ​ທ່ານ",
    name2: "ຕ້ອງການຄວາມຊ່ວຍເຫຼືອເພີ່ມເຕີມບໍ? ກະລຸນາຕິດຕໍ່ພວກເຮົາ.",
    name3: "ຂໍອະໄພ, ບໍ່ມີສູນ Carlcare ​ໃນ​ພາ​ກ​ພື້ນປະຈຸບັນ.",
    name4: "ກະລຸນາເລືອກສູນບໍລິການກ່ອນ",
    name5: "​ລົ້ມ​ເຫລວ",
    name6: "ກະລຸນາເລືອກລຸ້ນຂອງອຸປະກອນກ່ອນ",
    name7: "ລາຍລະອຽດ",
    name8: "ກ​ະ​ລຸ​ນາ​ອະ​ທິ​ບາຍ​ຄວາມ​ຕ້ອງ​ການ​ຂອງ​ທ່ານ​ຢ່າ​ງ​ລະ​ອຽດ",
    name9: "",
  },
  add1:{
    "name0": "lo-rLA",
    "name1": "ຄຳສັ່ງຊື້ຂອງທ່ານໄດ້ຮັບການຢືນຢັນແລ້ວ. ພວກເຮົາລໍຄອຍການມາເຖິງຂອງທ່ານ.",
    "name2": "ເລືອກເມືອງ",
    "name3": "ກະລຸນາປ້ອນໝາຍເລກໂທລະສັບ %1$s ຕົວເລກເຂົ້າ.",
    "name4": "ຊົ່ວໂມງມື້ທໍາມະດາ",
    "name5": "ວັນຈັນ",
    "name6": "ວັນອັງຄານ",
    "name7": "ວັນພຸດ",
    "name8": "ວັນພະຫັດ",
    "name9": "ວັນສຸກ",
    "name10": "ວັນເສົາ",
    "name11": "ວັນອາທິດ",
    "name12": "ປ້ອນປະເທດເຂົ້າ ແລະ ຄົ້ນຫາ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "ບຸກຄົນອື່ນໆ",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ແຕະເພື່ອປ່ຽນເສັ້ນທາງ",
    name3:"ເປີດແອັບ Carlcare ເພື່ອໃຫ້ຄະແນນຄໍາສັ່ງຊື້",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ເລືອກການບໍລິການ",
    name7:"ການເຮັດຄວາມສະອາດຟຣີ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ຂໍ້ມູນບໍ່ຖືກຕ້ອງ",
    "cancelReason1": "ບໍ່ສາມາດມາຮອດຕົງເວລາ",
    "cancelReason2": "ຄຳສັ່ງຊື້ຊ້ຳກັນ/ບໍ່ແມ່ນຄຳສັ່ງຊື້ຂອງຂ້ອຍ",
    "cancelReason3": "ຄວາມລົ້ມເຫຼວຈະບໍ່ເກີດຂຶ້ນອີກ",
    "cancelReason4": "ພຽງແຕ່ສຳລັບການທົດສອບ/ສອບຖາມ/ເຫດການ/…",
    "cancelReason5": "ລາຄາສູງ",
    "cancelReason6": "ການ​ຂາດ​ແຄນ​ວັດ​ສະ​ດຸ",
    "cancelReason7": "ບໍ່ມີການບໍລິການທີ່ແຕກຕ່າງ",
    "cancelReason8": "ຮ້ານ​ຢູ່​ໄກ​ເກີນ​ໄປ",
    "cancelReason9": "ຮ້ານ​ຄ້າ​ປິດ",
    "cancelReason10": "ທັດສະນະຄະຕິການບໍລິການບໍ່ດີ",
    "cancelReason11": "ການປ່ຽນແທນ/ສ້ອມແປງສຳລັບຍີ່ຫໍ້ອື່ນໆ",
    "cancelReason12": "ບໍ່ສາມາດຊອກຫາຮ້ານຄ້າ",
    "cancelReason13": "ອື່ນໆ",
    "cancelOrder": "​ຍົກ​ເລີກ​ການ​ສັ່ງ​ຊື້",
    "reason_dialog_title": "ກະ​ລຸ​ນາ​ບອກ​ເຫດ​ຜົນ​ການ​ຍົກ​ເລີກ​ແກ່​ພວກ​ເຮົາ",
    "Cancel": "ຍົກເລີກ",
    "OK": "ຕົກລົງ",
    "name1": "ປ້ອນລະຫັດໂຄດເພື່ອຢືນຢັນ",
    "name2": "​ລະ​ຫັດ​ການ​ກວດ​ສອບ​ບໍ່​ຖືກ​ຕ້ອງ",
    "repair_reservation_detail_canceled": "ຄຳສັ່ງຊື້ນີ້ໄດ້ຖືກຍົກເລີກແລ້ວ!",
    "purchase_cancel_dialog_content": "ທ່ານຢືນຢັນທີ່ຈະຍົກເລີກລາຍການສັ່ງຊື້ບໍ?",
    "yes": "\"ຕົກລົງ\"",
    "no": "\"ບໍ່\""
}
};
